import apiClient from 'enrollment-platform/api/enrollment-platform-client/api-client'
import {
  CreateStripePaymentIntentRequestDto,
  CreateStripePaymentIntentResponseDto,
  RetryStripePaymentIntentRequestDto,
} from './dto/invoice-delivery.dto'

const BASE_PATH = '/funding-invoice/stripe/customers'
const PAYMENT_INTENTS_PATH = '/funding-invoice/stripe/payment-intents'

/** Draws `body.amount` from one Stripe customer for the given billing period. */
export const createStripePaymentIntent = async (
  stripeCustomerId: string,
  body: CreateStripePaymentIntentRequestDto
): Promise<CreateStripePaymentIntentResponseDto> => {
  const response = await apiClient.post<CreateStripePaymentIntentResponseDto>(
    `${BASE_PATH}/${stripeCustomerId}/payment-intents`,
    body
  )
  return response.data
}

/** Re-attempts a failed PaymentIntent against `body.paymentMethod`. */
export const retryStripePaymentIntent = async (
  paymentIntentId: string,
  body: RetryStripePaymentIntentRequestDto
): Promise<unknown> => {
  const response = await apiClient.post(
    `${PAYMENT_INTENTS_PATH}/${paymentIntentId}/retry`,
    body
  )
  return response.data
}
